import React from 'react';
import { useUserContext } from '../../context/UserContextProvider';

interface PermissionBlockProps {
  readOnlyHide?: boolean;
  altElement?: React.ReactNode;
  readOnlyElement?: React.ReactNode;
  noPermissionMesssage?: string;
  children: React.ReactNode;
}

export const PermissionBlock = ({
  readOnlyHide = false,
  altElement = null,
  readOnlyElement = null,
  noPermissionMesssage,
  children,
}: PermissionBlockProps) => {
  const { permissions } = useUserContext();
  const isReadOnly = permissions?.isReadOnly ?? false;

  // hide if should be hidden for read-only users/licenses
  if (isReadOnly && readOnlyHide) {
    return <></>;
  }

  const userHasPermission = () => {
    return true;
  };

  // if user doesn't have permission, don't display children
  if (!userHasPermission()) {
    if (readOnlyElement && isReadOnly) {
      return <>{readOnlyElement}</>;
    }

    if (altElement) {
      return <>{altElement}</>;
    }

    if (noPermissionMesssage) {
      return (
        <>
          <div className="no-permission">{noPermissionMesssage}</div>
        </>
      );
    }

    return <>zzz</>;
  }

  return <>{children}</>;
};
